/**
 * The reader's box, as the page serves it to HeyDex's runtime worker
 * (`serveBox`): TrumanKit in the iOS app, truman's browser library in the page
 * everywhere else. Both keep the reader's files on this device.
 */
import type { BoxHost } from "@heydex/shared/box";

import { boxInApp } from "../appMode";
import { appBox } from "./app";
import { deleteWebBox, webBox } from "./web";

/** Opens the box of the reader `readerKey`; `close` gives it up so another page or a deletion can take it. */
export function startBox(readerKey: string): { host: BoxHost; close(): Promise<void> } {
  // The app's box outlives the page: the app holds it, so the page has nothing to close.
  return boxInApp ? { host: appBox(), close: async () => {} } : webBox(readerKey);
}

/**
 * Deletes the reader's box on this device; its box must be closed. In the iOS
 * app the box belongs to the app, which deletes it (TrumanKit's
 * `deleteNamespace("heydex-<reader key>")`) when the reader deletes their account.
 */
export async function deleteLocalBox(readerKey: string): Promise<void> {
  if (boxInApp) throw new Error("the HeyDay News app deletes its reader's box itself, with the reader's account");
  await deleteWebBox(readerKey);
}
